import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import SalesToolkit from '../../components/SalesToolkit';

const SalesToolkitPage = () => {
  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.Content>
          <SalesToolkit />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};

export default SalesToolkitPage;
